/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useSelector} from 'react-redux';

interface SideSheetContentProps {
  toggleSideSheet?: Function;
}

// [ION-APP TODO] Link Components for each sideSheet here
// **NOTE - Placeholder Component
const SideSheetDashboardContent = () => (
  <div>Dashboard SideSheet</div>
);

// **NOTE - Placeholder Component
const SideSheetDeviceTypeContent = () => (
  <div>Reports SideSheet</div>
);

/**
 * Provides the mapping of ION page navigation items to their respective
 * SideSheet Components.
 */
const sideSheetContentMap = {
  dashboard  : SideSheetDashboardContent,
  deviceType : SideSheetDeviceTypeContent
};

/**
 * @SideSheetContent
 *
 * The SideSheetContent component provides a map of the content
 * that would live in a side sheet per page
 */
export const SideSheetContent = ({toggleSideSheet}: SideSheetContentProps) => {
  const currentPage = useSelector(({nav}) => nav.currentPage);
  const page        = currentPage?.replace('/', '').split('?')[0];
  const Content     = sideSheetContentMap[page];

  return (Content ? (
    <Content toggleSideSheet={toggleSideSheet} />
  ) : null);
};

export default SideSheetContent;
